import styled from 'styled-components/macro';

export const GrassInfoRow = styled.div`
  width: 60%;
  margin-bottom: 20px;
  > div {
    width: 100%;
    &:first-child {
      margin-bottom: 10px;
      width: 100%;
      text-transform: uppercase;
      font-family: ${props => props.theme.primaryFontBold};
      font-weight: 200;
      font-size: ${props => props.theme.h5}px;
      padding: 25px 10px 0px 10px;
      display: flex;
      justify-content: center;
    }

    &:last-child {
      padding: 15px;
      height: auto;
      background-color: ${props => props.theme.lightWithOpacity};
      display: flex;

      > div {
        width: 33%;
      }
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    margin-top: 30px;
    > div {
      &:first-child {
        border-bottom: 0;
        margin-bottom: 0;
        padding: 10px;
      }

      &:last-child {
        height: auto;
        padding: 10px;

        > div {
          p:first-child {
            font-size: ${props => props.theme.label}px;
          }
        }
      }
    }
  }
`;
